export default __webpack_public_path__ + "53abe58.png";